require('angular').module('oly.common')
    .directive('olyOpenWindow', [require('./open-window.directive')]);



// WEBPACK FOOTER //
// ./src/olycommon/openwindow/index.js